/** Returns whether a given string is regex match.
 *
 * @param value String which will be evaluated
 * @param regex Regex expression (if not valid regexp, substring match is used)
 */
export function isRegexMatch(value, regex) {
    if (!value && regex)
        return false;
    if (value === regex)
        return true;
    return isValidRegex(regex)
        ? Boolean(value.match(new RegExp(regex, "i")))
        : value.includes(regex);
}
/** Checks if string is a valid regex.
 * @param value string being checked
 */
export function isValidRegex(value) {
    try {
        new RegExp(value);
        return true;
    }
    catch (_error) {
        return false;
    }
}
//# sourceMappingURL=regex.js.map